// extracted by mini-css-extract-plugin
module.exports = {"photoContainer":"photo_photoContainer__2pSuk","photo":"photo_photo__32PIA","btnDelete":"photo_btnDelete__9wLS_","btnSwitch":"photo_btnSwitch__17O1R","iconBtn":"photo_iconBtn__2UVco"};
    if(module.hot) {
      // 1783592043810
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  